import { colors } from 'ui/theme';
import { CustomNode } from '../../../types';
import { startIcon } from '../../../icons';

export const START_ACCENT_COLOR = colors.forest100;
export const START_BACKGROUND_ACCENT_COLOR = colors.forest100;
export const START_BORDER_ACCENT_COLOR = colors.forest100;
export const START_DEFAULT_ICON = startIcon;
export const START_DEFAULT_TITLE = 'Start when';

export const startNodeConfig: CustomNode = {
  getCustomConfig() {
    return {
      defaultTitle: START_DEFAULT_TITLE,
      accentColor: START_ACCENT_COLOR,
      activeBorderColor: START_BORDER_ACCENT_COLOR,
      icon: START_DEFAULT_ICON,
      accentColorBackground: START_BACKGROUND_ACCENT_COLOR,
    };
  },
};
